import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useState } from 'react';
import Places, { ConjuntoType, PlaceType } from '../../service/Places';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from 'moment';
import 'moment/locale/pt-br';
import { AiFillCopy, AiFillDelete, AiFillTool } from 'react-icons/ai';
import { PlacesWrapper } from './style';
import SetAcordeon from './SetAcordeon';
import { UserContext } from '../../context/UserContext';
import { toast } from 'react-toastify';
import AttToken from '../../helpers/attToken';
import { AxiosError } from 'axios';
import RemoveModal from './Modals/RemoveModal';
import Set from '../../service/Set';
import NewModal from './Modals/NewModal';
import { FaNetworkWired } from 'react-icons/fa';
import PlaceTypeAssoci from './Modals/AssociationsModals/PlaceTypeAssoci';
import NewPlaceModal from './Modals/NewPlaceModal';
import { Label } from '../Notifications/style/SingleNotificationStyle';
import { reorderType } from './PlacesComponent';
import { trackEventMatomo } from '../../helpers/matomo';
import { Accordion, AccordionSummary, Button, FormControl, IconButton, InputLabel, MenuItem, Select, Stack, Tooltip, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import QueryFn from '../../helpers/QueryFn';

const SetService = new Set();
const PlacesServices = new Places();
const queryFn = new QueryFn();

moment.locale('pt-br');

export type placeTypeToSend = {
  id: string,
  lat: number,
  lng: number,
  localizacao: string,
  nome: string,
};

type PlacesAcordeonType = {
  place: PlaceType,
  getPlaces: Function,
  selected: string[],
  setSelected: Function,
  handleChange: Function,
  expanded: string | false,
  local: reorderType,
  setLocal: Function,
  pages: any[],
  setCurrentPage: Function
};

export default function PlacesAcordeon({
  place,
  getPlaces,
  selected,
  setSelected,
  handleChange,
  expanded,
  local,
  setLocal,
  pages,
  setCurrentPage
}
  :
  PlacesAcordeonType
) {
  const { customerId, placesList, setPlacesList, editPlace, setEditPlace, popUp, openModal, setIsEditing, } = useContext(UserContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [attSets, setAttSets] = useState(false);
  const { hierarchyLabel } = useContext(UserContext);
  const [openRemove, setOpenRemove] = useState(false);
  const [associationModal, setAssociationModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [expandedConjs, setExpandedConjs] = useState<boolean[]>(place.conjuntosList.map(conj => false));
  const [reorderBy, setReorderBy] = useState<string>(local[place.id] || '');

  const { t } = useTranslation('translation');

  useEffect(() => {
    if (attSets) {
      setAttSets(false);
    }
  }, [attSets, getPlaces, selected, place.conjuntosList]);

  const { mutate } = queryFn.useMutate('removePlace',
    async () => {
      toast.warn(`${t('Services.ServicePlaces.removingPleaseWait')}`);
      try {
        const token = await AttToken();
        if (token) {
          await PlacesServices.deleteLocal(token, place.id, customerId);
          setSelected(selected.filter((e) => e !== place.id));
          setCurrentPage(1);
          getPlaces(customerId);
          toast.warn(`${hierarchyLabel.local} ${t('deleted')}!`);
          setOpenRemove(false);
        }

      } catch (err) {
        console.log(err);
        toast.error(`${t('Services.ServicePlaces.errorDeleting')}`);
      }
    });

  const { mutate: create } = queryFn.useMutate('CREATE_SET',
    async (name: string) => {
      setIsDisabled(true);
      try {
        const token = await AttToken();
        if (token) {
          const setObj = {
            cliente: customerId,
            dataAlteracao: Date.now(),
            listaEquipe: [],
            local: place.id,
            nome: name,
            unidades: []
          };
          await SetService.newConjunto(token, setObj);
          setModalOpen(false);
          setIsDisabled(false);
          getPlaces(customerId);
          toast.success(`${hierarchyLabel.conjunto} ${t('created')}!`);
        }
      } catch (err) {
        return console.log(err);
      }
    });

  const { mutate: clone } = queryFn.useMutate('CLONE_PLACE',
    async (placeid: string) => {
      trackEventMatomo('tela de locais', 'click', 'button', 'duplica local');
      toast.warn(`${t('Services.ServicePlaces.copyingPleaseWait')}`);
      try {
        const token = await AttToken();
        if (token) {
          const response = await PlacesServices.duplicateLocal(token, placeid);
          placesList && setPlacesList([...placesList, Object.values(response.updateLocal)[0]]);
          getPlaces(place.cliente);
          toast.success(`${t('Services.ServicePlaces.duplicatedLocation')}`);
        }
      } catch (err) {
        console.log(AxiosError);
        toast.error(`${t('Services.ServicePlaces.errorDuplicating')}`);
      }
    }
  );

  const placeToEdit = (value: string) => {
    const place = placesList && placesList.find((e) => e.id === value);
    if (place) setEditPlace({
      ...editPlace,
      id: place.id,
      lat: place.lat,
      lng: place.lng,
      localizacao: place.localizacao,
      nome: place.nome,
    });
  };

  const nameCreate = 'conjunto';
  const nameRemove = 'local';

  const switchSort = (value: string, a: ConjuntoType, b: ConjuntoType) => {
    switch (value) {
      case 'crescent':
        return (a.nome.toLowerCase() > b.nome.toLowerCase());
      case 'decrescent':
        return (a.nome.toLowerCase() < b.nome.toLowerCase());
      default: return (a.nome.toLowerCase() > b.nome.toLowerCase());
    }
  };

  return (
    <>
      {associationModal &&
        <PlaceTypeAssoci
          place={place}
          open={associationModal}
          setOpen={setAssociationModal}
          getPlaces={getPlaces}
        />}
      {openRemove &&
        <RemoveModal
          mutate={mutate}
          openRemove={openRemove}
          setOpenRemove={setOpenRemove}
          nameRemove={nameRemove}
        />}
      {modalOpen &&
        <NewModal
          isDisabled={isDisabled}
          nameCreate={nameCreate}
          create={create}
          setModalOpen={setModalOpen}
          modalOpen={modalOpen}
        />}
      {popUp && <NewPlaceModal getPlaces={getPlaces} />}
      <Accordion expanded={expanded === place.id} style={{ marginTop: '10px' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon onClick={(isExpanded) => {
            trackEventMatomo('tela de locais', 'click', 'acordeon', 'abre/fecha');
            if (expanded === place.id) {
              handleChange(!isExpanded, '');
            } else handleChange(isExpanded, place.id);
          }} />}
          aria-controls={place.id}
          id={place.id}>
          <PlacesWrapper>
            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={0.5}
            >
              <Typography sx={{ color: '#4AA78A' }} variant='h6' fontWeight={600}>
                {place.nome}
              </Typography>
              <Typography variant='caption' color='textSecondary'>
                {`${t('Services.ServicePlaces.createdOn')} 
                ${moment(place.dataCadastro).format('DD/MM/YYYY | HH:mm')} 
                ${t('Services.ServicePlaces.by')} 
                ${place.userOwner ? place.userOwner : '--'}`}
              </Typography>
              <Typography variant='caption' color='textSecondary'>
                {place.localizacao}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
            >
              <Tooltip title={`${t('teamManage.register.kindOfService')}`}>
                <IconButton aria-label="services">
                  <FaNetworkWired
                    onClick={() => {
                      trackEventMatomo('tela de locais', 'click', 'button', 'abre modal');
                      setAssociationModal(true);
                    }} size={25} />
                </IconButton>
              </Tooltip>
              <Tooltip title={`${t('edit')} ${hierarchyLabel.local}`}>
                <IconButton aria-label="edit" color='info'>
                  <AiFillTool
                    onClick={() => {
                      trackEventMatomo('tela de locais', 'click', 'button', 'abre modal');
                      placeToEdit(place.id);
                      setIsEditing(true);
                      openModal();
                    }} size={25} />
                </IconButton>
              </Tooltip>
              <Tooltip title={`${t('checklists.checklists.clone')} ${hierarchyLabel.local}`}>
                <IconButton aria-label="edit" color='success'>
                  <AiFillCopy onClick={() => clone(place.id)} size={25} />

                </IconButton>
              </Tooltip>
              <Tooltip title={`${t('delete')} ${hierarchyLabel.local}`}>
                <IconButton aria-label="delete" color='error'>
                  <AiFillDelete
                    onClick={() => {
                      trackEventMatomo('tela de locais', 'click', 'button', 'deleta local');
                      setOpenRemove(true);
                    }}
                    size={25}
                  />
                </IconButton>
              </Tooltip>
            </Stack>
          </PlacesWrapper>
        </AccordionSummary>
        <Button
          sx={{ marginLeft: '10px' }}
          endIcon={<AddCircleIcon />}
          className='button is-success'
          onClick={() => {
            trackEventMatomo('tela de locais', 'click', 'button', 'abre modal');
            setModalOpen(!modalOpen);
          }}
        >
          {`${t('add')} ${hierarchyLabel.conjunto}`}
        </Button>
        <Stack
          sx={{ marginTop: '10px', marginBottom: '10px' }}
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Label style={{ marginLeft: '5px', fontSize: '15px' }}>{hierarchyLabel.conjunto}:</Label>
          <FormControl sx={{ width: '300px' }}>
            <InputLabel id="demo-simple-select-label">{t('Services.servicesManagement.sortBy')}</InputLabel>
            <Select
              size='small'
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={reorderBy}
              label={t('Services.servicesManagement.sortBy')}
              onChange={(event) => {
                setReorderBy(event.target.value);
                setReorderBy(event.target.value);
                local[place.id] = event.target.value;
                setLocal(local);
                localStorage.setItem('localOrder', JSON.stringify(local));
              }}
            >
              <MenuItem value={'crescent'}>{t('Services.servicesManagement.alphabeticalAscending')} (A-Z)</MenuItem>
              <MenuItem value={'decrescent'}>{t('Services.servicesManagement.alphabeticalDescending')} (Z-A)</MenuItem>
            </Select>
          </FormControl>
        </Stack>
        {place.conjuntosList && place.conjuntosList.sort((conjuntoA, conjuntoB) => { return switchSort(reorderBy, conjuntoA, conjuntoB) ? 1 : - 1; }).map((e, i) => (
          <SetAcordeon
            key={i}
            local={local}
            setLocal={setLocal}
            set={e}
            placeId={place.id}
            getPlaces={getPlaces}
            selected={selected}
            conjuntosList={place.conjuntosList}
            expandedConjs={expandedConjs}
            setExpandedConjs={setExpandedConjs}
            index={i}
          />
        ))}
      </Accordion>
    </>
  );
}
